import axios from "axios";
import { LoginModel } from "../../datamodels/auth/loginModel";

export async function sendLoginApiCall(
  passedPhoneNo: string,
  passedUsername: String,
  passedPassword: String,
  passedPhoneLogin: Boolean,
  passedCountryCode?: string
) {
  const response = await axios.post<LoginModel>(
    // `${process.env.REACT_APP_BASE_URL}v1/auth/login`,
    `/user/Auth/Login`,
    {
      countryCode: passedCountryCode,
      phoneNo: passedPhoneNo,
      userName: passedUsername,
      password: passedPassword,
      phoneLogin: passedPhoneLogin,
      deviceInfo: {
        appOS: "Web",
        appVersion: "1.0.0",
        notificationId: "test",
      },
    },
    {
      headers: {
        "Basic-Auth": process.env.REACT_APP_BASIC_AUTH,
        "Content-Type": "application/json",
      },
    }
  );
  if (response.data.responseInfo.httpCode === 200) {
    return response.data;
  } else {
    return response.data;
  }
}

export async function sendLoginPhoneOTPApiCall(
  passedPhoneNo: string,
  passedPhoneLogin: Boolean,
  passedCountryCode?: string
) {
  const response = await axios.post<LoginModel>(
    // `${process.env.REACT_APP_BASE_URL}v1/auth/otp/login`,
    `/user/Auth/Login/OTP`,
    {
      countryCode: passedCountryCode,
      phoneNo: passedPhoneNo,
      phoneLogin: passedPhoneLogin,
      deviceInfo: {
        appOS: "Web",
        appVersion: "1.0.0",
        notificationId: "test",
      },
    },
    {
      headers: {
        "Basic-Auth": process.env.REACT_APP_BASIC_AUTH,
        "Content-Type": "application/json",
      },
    }
  );
  if (response.data.responseInfo.httpCode === 200) {
    return response.data;
  } else {
    return response.data;
  }
}

export async function verifyLoginPhoneOTPApiCall(
  passedPhoneNo: string,
  passedPhoneLogin: Boolean,
  passedOTP: string,
  passedCountryCode?: string
) {
  const response = await axios.post<LoginModel>(
    // `${process.env.REACT_APP_BASE_URL}v1/auth/verify/login`,
    `/user/Auth/Login/Verify`,
    {
      countryCode: passedCountryCode,
      phoneNo: passedPhoneNo,
      phoneLogin: passedPhoneLogin,
      otp: passedOTP,
    },
    {
      headers: {
        "Basic-Auth": process.env.REACT_APP_BASIC_AUTH,
        "Content-Type": "application/json",
      },
    }
  );
  if (response.data.responseInfo.httpCode === 200) {
    return response.data;
  } else {
    return response.data;
  }
}

export async function sendLoginEmailOTPApiCall(passedUserName: string) {
  const response = await axios.post<LoginModel>(
    // `${process.env.REACT_APP_BASE_URL}v1/auth/otp/login`,
    `/user/Auth/Login/OTP`,
    {
      userName: passedUserName,
      phoneLogin: false,
    },
    {
      headers: {
        "Basic-Auth": process.env.REACT_APP_BASIC_AUTH,
        "Content-Type": "application/json",
      },
    }
  );
  if (response.data.responseInfo.httpCode === 200) {
    return response.data;
  } else {
    return response.data;
  }
}

export async function verifyLoginEmailOTPApiCall(
  passedUserName: string,
  passedOTP: string
) {
  const response = await axios.post<LoginModel>(
    // `${process.env.REACT_APP_BASE_URL}v1/auth/verify/login`,
    `/user/Auth/Login/Verify`,
    {
      userName: passedUserName,
      phoneLogin: false,
      otp: passedOTP,
    },
    {
      headers: {
        "Basic-Auth": process.env.REACT_APP_BASIC_AUTH,
        "Content-Type": "application/json",
      },
    }
  );
  if (response.data.responseInfo.httpCode === 200) {
    return response.data;
  } else {
    return response.data;
  }
}
